import { Box, IconButton, useTheme } from "@mui/material"
import { tokens } from "../../../../theme";
import { useTranslation } from "react-i18next";
import BaseCard from "../../../theme/cards/BaseCard";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";


export const InvoiceCostsCard = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    
    let labelColor = "grey";
    switch(props.type) {
        case "shipment" :
            labelColor = "blue";
            break;
        case "pickandpack" :
            labelColor = "orange";
            break;
        case "storage_pallet" :
            labelColor = "pink";
            break;
        case "storage_product" :
            labelColor = "purple";
            break;
        default:
            labelColor = "grey";
            break;
    }
    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick} sx={{p:0,pb:2,}}>
            <Box>
                <Box>
                    <Box display={"flex"}
                        sx={{
                            gap:3,
                        }}
                    >
                        <Box
                            sx={{
                                minWidth:170,
                                display:"flex",
                                flexDirection:"column",
                                pt:2,
                                pl:2,
                                overflow:"hidden",
                                flex:1,
                            }}
                        >
                            {props.skeleton ? 
                                <ShDoubleTextSkeleton/> 
                                :
                                <>
                                    <Text noBreak bold>{props.name}</Text>
                                    <Text>{props.ivnoiceType ? t(`invoice_type_${props.invoiceType}`) : t('unknown')}</Text>
                                </>
                            }
                        </Box>
                        
                        <Box
                            sx={{
                                width:"fit-content",
                            }}
                        >
                            <CardLabel palette={"pastel"} variant={labelColor}  position="child-tr">
                                {props.skeleton ? 
                                    <ShDoubleTextSkeleton/> 
                                    :
                                   t(props.type)
                                }
                            </CardLabel>
                        </Box>
                    </Box>

                    

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3} pl={2}>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("shipper")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Text>
                                    {props.shipper?.name}    
                                </Text>
                            }
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("invoice_product")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Text>
                                    {props.invoiceProduct?.name}    
                                </Text>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

